import { render, staticRenderFns } from "./productClass__list.vue?vue&type=template&id=4cd6399b"
import script from "./productClass__list.vue?vue&type=script&lang=js"
export * from "./productClass__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports